<template>
  <b-container>
    <b-row>
      <b-col>
        <h6 class="subtitle">Teachers</h6>
        <div>
          <b-button-group v-show="add">
            <b-button @click="openTab=true">Teachers</b-button>
            <b-button @click="openTab=false">Import Group</b-button>
          </b-button-group>
        </div>
        <group-teacher v-if="isAdmin || isSRC && openTab"></group-teacher>
        <group-teacher-search v-if="isAdmin || isSRC && !openTab"></group-teacher-search>
      </b-col>
      <b-col>
        <h6 class="subtitle">Teachers currently in the Group</h6>
        <b-form-group>
        
          <div >
            <b-col>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="filteredResults"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!filteredResults"
                      @click="filteredResults = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="groupTeacherFields"
              :items="teacherTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filteredResults"
              @filtered="filteredTeachers"
            >
              <template slot="cell(teacher_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{ name: 'EditTeacher', params: { id: row.item.uuid } }"
                  >{{ row.item.name }}</b-link
                >
                <br />
              </template>
              <template slot="cell(uuid)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="delete"
                  @click.stop="removeTeacher(row.item.uuid)"
                  >DELETE</b-link
                >
              </template>
              <template slot="cell(id)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="delete"
                  @click.stop="removeTempTeacher(row.item.uuid)"
                  >Temp DELETE</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="teacherTable.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import GroupTeacher from "./GroupTeachersList";
import GroupTeacherSearch from "./GroupTeacherSearch";

export default {
  name: "GroupTeachers",
  components: {
    GroupTeacher,
    GroupTeacherSearch
  },
  data() {
    return {
      groupTeacherFields: [
        { key: "teacher_name", label: "name", sortable: true },
        { key: "id", label: "REMOVE TEACHER" },
      ],
      currentPage: 1,
      perPage: 5,
      filteredResults: null,
      openTab:true
    };
  },
  methods: {
    ...mapActions({
      DELETE_TEACHER: "groups/DELETE_TEACHER",
      DELETE_TEMP_TEACHER: "groups/DELETE_TEMP_TEACHER",
      GET_GROUP_TEACHERS: "groups/GET_GROUP_TEACHERS",
    }),
    async removeTeacher(uuid) {
      
      const confirmDelete = confirm(
        "Are you sure you want to remove this teacher from this group?"
      );
      if (confirmDelete) {
        const teachersIds = [...this.$store.state.groups.group.teachers];
        const teachersNames = [...this.$store.state.groups.group.teacher_names];

      
        const index = teachersIds.findIndex(tid => tid == uuid);
        
        if (!this.add) {
          await this.DELETE_TEACHER({ id: uuid });
        }

        teachersIds.splice(index, 1);
        teachersNames.splice(index, 1);
        this.$store.commit("groups/teachers", teachersIds);
        this.$store.commit("groups/teacher_names", teachersNames);

        const results = [];
        // eslint-disable-next-line
        for (let i = 0; i < teachersIds.length; i++) {
          const obj = { id: teachersIds[i], teacher_name: teachersNames[i] };
          results.push(obj);
        }

        if (!this.add) {
          await this.GET_GROUP_TEACHERS();
        }
      }
    },
    async removeTempTeacher(uuid) {
      
      const confirmDelete = confirm(
        "Are you sure you want to remove this teacher from this group?"
      );
      if (confirmDelete) {
        const teachersIds = [...this.$store.state.groups.group.teachers];
        const teachersNames = [...this.$store.state.groups.group.teacher_names];

      
        const index = teachersIds.findIndex(tid => tid == uuid);
        
        if (!this.add) {
          await this.DELETE_TEMP_TEACHER({ id: uuid });
        }

        teachersIds.splice(index, 1);
        teachersNames.splice(index, 1);
        this.$store.commit("groups/teachers", teachersIds);
        this.$store.commit("groups/teacher_names", teachersNames);

        const results = [];
        // eslint-disable-next-line
        for (let i = 0; i < teachersIds.length; i++) {
          const obj = { id: teachersIds[i], teacher_name: teachersNames[i] };
          results.push(obj);
        }

        if (!this.add) {
          await this.GET_GROUP_TEACHERS();
        }
      }
    },
    stopClick() {},
    filteredTeachers(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  computed: {
    ...mapGetters({
      teachers: "groups/groupTeachersObj",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    add() {
      return this.$route.path.includes("/add") ? true : false;
    },
    groupTeachers: {
      get() {
        return this.$store.state.groups.groupTeachers;
      },
    },
    groupTeachersNames: {
      get() {
        return this.$store.state.groups.group.teacher_names;
      },
    },
    groupTeachersIds: {
      get() {
        return this.$store.state.groups.group.teachers;
      },
    },
    teacherTable() {
     // if (!this.$store.state.groups.group.openTab) {
      if (!this.add) {
        const teachers = this.groupTeachers.map((k) => ({
          id: k.id,
          uuid: k.uuid,
          name: `${k.first_name} ${k.last_name}`,
          active: k.active,
        }));
        return teachers;
      } else {
        
        const ids = this.groupTeachersIds;
        const teachers = this.groupTeachersNames.map(function(obj, index) {
          return {
            id: null,
            uuid: ids[index],
            name: obj,
            active: true,
          };
        });
        return teachers;
      }
    },
  },
  watch: {
    teachers(val) {
      console.log("val: ", val);
    },
  },
  created() {
    if (!this.$route.path.includes("/add")) {
      this.GET_GROUP_TEACHERS();
    }
  },
};
</script>
